<template>
  <div class="sf-page">
    <top-header v-bind:title="$t('emailJobs')">
      <v-btn color="primary"
             outlined
             slot="right-button"
             v-on:click="load">
        <v-icon left>ti-refresh</v-icon>
        {{ $t('refresh') }}
      </v-btn>
    </top-header>
    <email-test-mode-banner />
    <v-progress-linear color="accent"
                       indeterminate
                       v-bind:active="loading" />
    <div class="sf-container">
      <v-card class="sf-card"
              flat>
        <v-data-table class="sf-table--clickable"
                      disable-sort
                      hide-default-footer
                      v-bind:headers="headers"
                      v-bind:items="emailJobs"
                      v-bind:items-per-page="-1"
                      v-bind:no-data-text="$t('noJobs')"
                      v-on:click:row="open">
          <template v-slot:item.created="{ item }">
            {{ item.created | formatDate('L LT') }}
          </template>
          <template v-slot:item.audience="{ item }">
            {{ item.audience === 'Supplier' ? $t('suppliers') : $t('customers') }}
          </template>
          <template v-slot:item.kind="{ item }">
            {{ item.kind === 'Transactional' ? $t('transactional') : $t('campaign') }}
          </template>
          <template v-slot:item.status="{ item }">
            <email-job-status-chip v-bind:status="item.status" />
          </template>
          <template v-slot:item.progress="{ item }">
            <span class="sf-tabular">
              <span class="success--text">{{ item.sent }}</span> /
              <span v-bind:class="{ 'error--text': item.failed > 0 }">{{ item.failed }}</span> /
              <span>{{ item.pending }}</span>
              <span class="sf-muted">({{ item.total }})</span>
            </span>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  import EmailJobStatusChip from '@/components/administration/EmailJobStatusChip'
  import EmailTestModeBanner from '@/components/administration/EmailTestModeBanner'
  import TopHeader from '@/components/common/TopHeader'

  export default {
    beforeDestroy() {
      clearInterval(this.timer)
    },
    components: {
      EmailJobStatusChip,
      EmailTestModeBanner,
      TopHeader
    },
    computed: {
      ...mapGetters([ 'emailJobs' ]),
      headers() {
        return [
          { text: this.$t('created'), value: 'created' },
          { text: this.$t('template'), value: 'templateName' },
          { text: this.$t('audience'), value: 'audience' },
          { text: this.$t('kind'), value: 'kind' },
          { text: this.$t('status'), value: 'status' },
          { text: this.$t('progress'), value: 'progress', align: 'end' }
        ]
      },
      hasRunning() {
        return this.emailJobs.some(j => j.status === 'Pending' || j.status === 'Running')
      }
    },
    async created() {
      this.loading = true
      await Promise.all([ this.load(), this.$store.dispatch('loadEmailDesignerData') ])
      this.loading = false

      this.timer = setInterval(() => {
        if (this.hasRunning) {
          this.load()
        }
      }, 5000)
    },
    data: () => ({
      loading: false,
      timer: null
    }),
    methods: {
      async load() {
        await this.$store.dispatch('loadEmailJobs', { limit: 200 })
      },
      open(item) {
        this.$router.push({ name: 'administration-email-job', params: { id: item.id } })
      }
    },
    name: 'EmailJobs'
  }
</script>

<style scoped>
  .sf-table--clickable >>> tbody tr {
    cursor: pointer;
  }
</style>

<i18n>
  {
    "de": {
      "emailJobs": "Versandprotokoll",
      "noJobs": "Noch keine Versandaufträge.",
      "created": "Erstellt",
      "template": "Vorlage",
      "audience": "Zielgruppe",
      "customers": "Kunden",
      "suppliers": "Lieferanten",
      "kind": "Art",
      "campaign": "Kampagne",
      "transactional": "Einzelmail",
      "status": "Status",
      "progress": "Gesendet / Fehler / Offen",
      "refresh": "Aktualisieren"
    },
    "en": {
      "emailJobs": "Email log",
      "noJobs": "No email jobs yet.",
      "created": "Created",
      "template": "Template",
      "audience": "Audience",
      "customers": "Customers",
      "suppliers": "Suppliers",
      "kind": "Kind",
      "campaign": "Campaign",
      "transactional": "Single email",
      "status": "Status",
      "progress": "Sent / Failed / Pending",
      "refresh": "Refresh"
    }
  }
</i18n>
